export default (function (value) {
  return typeof value === 'symbol' || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isSymbol.js
// module id = Ijtg
// module chunks = 0